import { render } from "./TopScorer.vue?vue&type=template&id=6ef184bd"
import script from "./TopScorer.vue?vue&type=script&lang=js"
export * from "./TopScorer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__